import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const LEAD_CONTEXT_KEY = 'lead_context_v1';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);

            const totalScroll = document.documentElement.scrollTop;
            const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const progress = windowHeight > 0 ? (totalScroll / windowHeight) * 100 : 0;
            setScrollProgress(Math.min(100, Math.max(0, progress)));
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        // Prevent background scroll when mobile menu is open (better UX on small screens)
        document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [isMobileMenuOpen]);

    // Added: Auto-close menu on resize (fixes rotation issues on tablets)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 900 && isMobileMenuOpen) {
                setIsMobileMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isMobileMenuOpen]);

    useEffect(() => {
        if (!isMobileMenuOpen) return;
        const onKeyDown = (e) => {
            if (e.key === 'Escape') setIsMobileMenuOpen(false);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [isMobileMenuOpen]);

    const toggleMenu = () => setIsMobileMenuOpen((v) => !v);

    const setLeadContext = (ctx) => {
        try { window.localStorage.setItem(LEAD_CONTEXT_KEY, JSON.stringify(ctx)); } catch { /* no-op */ }
    };

    return (
        <>
            <div className="scroll-progress-container">
                <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }}></div>
            </div>
            <button
                type="button"
                className={`nav-backdrop ${isMobileMenuOpen ? 'active' : ''}`}
                aria-label="Close menu"
                tabIndex={-1}
                onClick={() => setIsMobileMenuOpen(false)}
            />
            <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
                <div className="container nav-container">
                    <Link to="/" className="logo" onClick={() => setIsMobileMenuOpen(false)}>
                        <img src="/logo/l6.jpeg" alt="" className="logo-mark" />
                        <span>AI Consulting SA</span>
                    </Link>

                    <button
                        type="button"
                        className="mobile-menu-btn"
                        onClick={toggleMenu}
                        aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                        aria-expanded={isMobileMenuOpen ? 'true' : 'false'}
                        aria-controls="primary-navigation"
                    >
                        <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`} aria-hidden="true"></i>
                    </button>

                    <ul
                        id="primary-navigation"
                        className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}
                    >
                        <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link></li>
                        <li><Link to="/about" onClick={() => setIsMobileMenuOpen(false)}>About</Link></li>
                        <li><Link to="/services" onClick={() => setIsMobileMenuOpen(false)}>Services</Link></li>
                        <li><Link to="/case-studies" onClick={() => setIsMobileMenuOpen(false)}>Case Studies</Link></li>
                        <li>
                            <Link
                                to="/readiness"
                                onClick={() => setIsMobileMenuOpen(false)}
                                className="nav-link-featured"
                            >
                                <span className="nav-dot" aria-hidden="true"></span>
                                AI Readiness
                            </Link>
                        </li>
                        <li><Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</Link></li>
                        <li>
                            <Link
                                className="nav-cta"
                                to="/contact"
                                onClick={() => {
                                    setLeadContext({ message: 'Requesting a discovery call. Please propose next steps.' });
                                    setIsMobileMenuOpen(false);
                                }}
                            >
                                Get Started
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
